import script from "./Form.vue?vue&type=script&setup=true&lang=js"
export * from "./Form.vue?vue&type=script&setup=true&lang=js"

import "./Form.vue?vue&type=style&index=0&id=b221f96c&lang=scss&scoped=true"

import exportComponent from "E:\\东智商户端源码\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b221f96c"]])

export default __exports__